import { render, staticRenderFns } from "./ProfilePictureDirect.vue?vue&type=template&id=2cd604f8&scoped=true"
import script from "./ProfilePictureDirect.vue?vue&type=script&lang=ts"
export * from "./ProfilePictureDirect.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePictureDirect.vue?vue&type=style&index=0&id=2cd604f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd604f8",
  null
  
)

export default component.exports